import { Fragment } from 'react';

type Props = {
    current: number;
    total: number;
};

/** Connected-dots progress indicator: filled dots/lines up to the current step. */
export const StepProgress = ({ current, total }: Props) => (
    <div className="flex items-center gap-2" aria-hidden="true">
        {Array.from({ length: total }).map((_, index) => (
            <Fragment key={index}>
                <span
                    className={`h-2.5 w-2.5 shrink-0 rounded-full transition-colors ${
                        index <= current ? 'bg-wm-accent' : 'bg-wm-line'
                    }`}
                />
                {index < total - 1 && (
                    <span
                        className={`h-px flex-1 transition-colors ${index < current ? 'bg-wm-accent' : 'bg-wm-line'}`}
                    />
                )}
            </Fragment>
        ))}
    </div>
);
